import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Custom
import { startLoading, endLoading } from 'actions';
import { getHocDisplayName } from 'utils/Tools';

const withLoading = (WrappedComponent) => {
  const WithLoading = ({ handleStartLoading, handleEndLoading, ...otherProps }) => (
    <WrappedComponent
      handleStartLoading={handleStartLoading}
      handleEndLoading={handleEndLoading}
      {...otherProps}
    />
  );

  WithLoading.displayName = getHocDisplayName('WithLoading', WrappedComponent);

  WithLoading.propTypes = {
    handleStartLoading: PropTypes.func.isRequired,
    handleEndLoading: PropTypes.func.isRequired,
  };

  const mapDispatchToProps = (dispatch) => ({
    handleStartLoading: () => dispatch(startLoading()),
    handleEndLoading: () => setTimeout(() => dispatch(endLoading()), 1000),
  });

  return connect(
    null,
    mapDispatchToProps,
  )(WithLoading);
};

export default withLoading;



// WEBPACK FOOTER //
// ./hocs/WithLoading.js